module.exports = __webpack_public_path__ + "static/media/1009828.cd0f24f4.jpg";